export const ButtonVariantEnum = {
    WHITE: 'WHITE',
    BLACK: 'BLACK'
};